export function GoCrossPlatformSection() {
  return (
    <div className="mk-section">
      <div className="mk-container mk-text-center" style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
        <span className="mk-chip">
          <span className="mk-chip-icon">
            <img src="/marketing/go/icons/cross-plattform.svg" alt="" />
          </span>
          Download now
        </span>

        <h2 className="mk-title">
          Available on <span className="mk-title-accent">All Your Devices</span>
        </h2>

        <div className="mk-download-badges">
          <a
            href="https://apps.apple.com/app/to-to-do-list-schedule-planner/id1669928204"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src="/get-it-on/Download_on_the_App_Store_Badge_US-UK_RGB_blk_092917.svg"
              alt="Download on the App Store"
            />
          </a>
          <a
            href="https://play.google.com/store/apps/details?id=app.totodo.com"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src="/get-it-on/GetItOnGooglePlay_Badge_Web_color_English.png"
              alt="Get it on Google Play"
            />
          </a>
          <a href="https://totodo.app" target="_blank" rel="noopener noreferrer">
            <img
              src="/get-it-on/visit-on-the-web-badge.png"
              alt="Visit on the Web"
            />
          </a>
        </div>
      </div>
    </div>
  )
}
